import { apiClient } from './client';
import {
  CompleteProfileData,
  CompleteProfileResponse,
  KycLevelCompletionResponse,
  BvnVerificationResponse,
  KycStatusResponse,
} from '@/lib/types/kyc.type';

export const kycApi = {
  // Complete profile (BVN + Bank details)
  completeProfile: (data: CompleteProfileData) =>
    apiClient.post<CompleteProfileResponse>('/kyc/complete-profile', data),

  // Check if KYC level is completed
  checkKycLevelCompletion: (kycLevelId: string) =>
    apiClient.get<KycLevelCompletionResponse>(`/kyc/levels/${kycLevelId}/completed`),

  // Check if BVN is verified
  checkBvnVerification: () =>
    apiClient.get<BvnVerificationResponse>('/kyc/bvn/verified'),

  // Get full KYC status
  getKycStatus: () =>
    apiClient.get<KycStatusResponse>('/kyc/kyc-status'),
};
